import Component from '../abstracts/Component';

export default class CollapseComponent extends Component {

  get COMPONENTNAME() {
    return 'CollapseComponent';
  }

  get SELECTORS() {
    return {
      trigger: '[data-trigger]',
      tab: '[data-tab]',
    };
  }

  get CLASSES() {
    return {
      collapsed: 'collapsed'
    }
  }

  constructor(compEl) {
    super(compEl);
  }

  readDOM() {
    return {
      triggers: this.$component.querySelectorAll(this.SELECTORS.trigger),
      tabs: this.$component.querySelectorAll(this.SELECTORS.tab),
      currentOpenTab: null,
      buttons: this.$component.querySelectorAll('button[aria-expanded]'),
    };
  }

  // Update ARIA attributes for accessibility
  updateAriaAttributes(trigger, isExpanded) {
    const button = trigger.querySelector('button[aria-expanded]') || trigger;
    if (button) {
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  }

  //get all the tabs and set the height
  init() {
    if(this.dom.tabs) {
      this.dom.tabs.forEach(tab => {
        tab.style.maxHeight = this.getHiddenHeight(tab) + "px";
      });
    }
    if(this.dom.triggers) {
      this.dom.triggers.forEach(trigger => {
        const tab = trigger.parentNode.querySelector(this.SELECTORS.tab);
        if(trigger.dataset.trigger === "start-open") {
          trigger.dataset.trigger = "on";
          this.dom.currentOpenTrigger = trigger;
          this.updateAriaAttributes(trigger, true);

        } else {
          tab.classList.add(this.CLASSES.collapsed);
          trigger.classList.add(this.CLASSES.collapsed);
          trigger.dataset.trigger = "off";
          this.updateAriaAttributes(trigger, false);
        }
      });
    }
    // remove display: none AFTER collapsed class is set to avoid flickering
    if(this.dom.tabs) {
      this.dom.tabs.forEach(tab => {
        tab.style.display = 'block';
      });
    }
  }

  refreshHeight(event, payload) {
    // context
    let ctx = this;
    // check
    if (payload.btn === null) return false;
    // let's find the component
    let comp = payload.btn.closest('[data-js-component]');
    if (comp !== null) {
      comp.querySelector(ctx.SELECTORS.tab).style.height = comp.querySelector(ctx.SELECTORS.tab).children[0].offsetHeight + "px";
    }
  }

  //handle click on trigger element
  handleCollapse() {
    if(this.dom.triggers) {
      this.dom.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
          //get trigger-related tab
          const tab = trigger.parentNode.querySelector(this.SELECTORS.tab);
          if(this.dom.currentOpenTrigger === trigger) {
            // click on the same trigger to close the section
            tab.style.maxHeight = "0px";
            tab.classList.add(this.CLASSES.collapsed);
            trigger.classList.add(this.CLASSES.collapsed);
            trigger.dataset.trigger = "off";
            this.dom.currentOpenTrigger = null;
            this.updateAriaAttributes(trigger, false);
          } else if (this.dom.currentOpenTrigger != null) {
            //another tab is currently open
            //find current open tab to close it
            const currentOpenTab = this.dom.currentOpenTrigger.parentNode.querySelector(this.SELECTORS.tab);
            currentOpenTab.style.maxHeight = "0px";
            currentOpenTab.classList.add(this.CLASSES.collapsed);
            this.dom.currentOpenTrigger.classList.add(this.CLASSES.collapsed);
            this.dom.currentOpenTrigger.dataset.trigger = "off";
            this.updateAriaAttributes(this.dom.currentOpenTrigger, false);
            tab.style.maxHeight = tab.scrollHeight + "px";
            tab.classList.remove(this.CLASSES.collapsed);
            trigger.classList.remove(this.CLASSES.collapsed);
            trigger.dataset.trigger = "on";
            this.dom.currentOpenTrigger = trigger;
            this.updateAriaAttributes(this.dom.currentOpenTrigger, true);
          } else {
            //is the first trigger clicked
            tab.classList.remove(this.CLASSES.collapsed);
            tab.style.maxHeight = tab.scrollHeight + "px";
            trigger.classList.remove(this.CLASSES.collapsed);
            trigger.dataset.trigger = "on";
            this.dom.currentOpenTrigger = trigger;
            this.updateAriaAttributes(trigger, true);
          }
        });
      });
    }
  }

  // get height of hidden elements, avoids seeing element open during page load
  getHiddenHeight(el) {
    if(!el?.cloneNode) {
      return null;
    }

    const clone = el.cloneNode(true);
    const parentWidth = el.parentNode.offsetWidth;
    Object.assign(clone.style, {
      overflow: 'visible',
      height: 'auto',
      width: parentWidth + 'px',
      position: 'absolute',
      opacity: '0',
      visibility: 'hidden',
      display: 'block',
    });

    const radios = clone.querySelectorAll('input[type="radio"]')
    if (radios.length > 0){
      radios.forEach((radio) => {
        const randomStr = Math.random().toString(36).substring(2, 10);
        radio.id = randomStr;
        radio.name = randomStr;
      })
    }
    el.after(clone);
    const height = clone.offsetHeight;

    clone.remove();

    return height;
  }

  bindEvents() {
    this.handleCollapse();
    this.$on(this.$customEvents.COLLAPSE_EVENTS.update,({event, payload}) => {
      this.refreshHeight(event, payload);
    });
    window.addEventListener('resize', () => {
      if (this.dom.currentOpenTrigger) {
        const tab = this.dom.currentOpenTrigger.parentNode.querySelector(this.SELECTORS.tab);
        tab.style.maxHeight = tab.scrollHeight + "px";
      }
    });
  }

  render() {
    super.render();
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.init();
    this.bindEvents();
  }
}
